<template>
  <a v-if="value" :href="href" :target="value.external ? '_blank' : ''">
    <template v-if="slot">
      <slot/>
    </template>
    <template v-else>
      {{ value.name }}
    </template>
  </a>
</template>

<script>
export default {
  name: "smart-link",
  props: {
    value: {
      type: Object, // LinkData
    }
  },
  computed: {
    href: function () {
      if (this.value.target && this.value.target.startsWith("/") && !this.value.target.startsWith(window.contextPath)) {
        return window.contextPath + this.value.target;
      }
      return this.value.target;
    },
    slot: function () {
      return !!this.$scopedSlots.default;
    },
  },
}
</script>